$.fn.searchNotes = function (options) {
    'use strict';

    var _elem = $(this),  // instance to $('#selector')
        _this = this,     // instance to this plugin
        _notes = $(this).find('.notes-wrapper');

    // custom variables
    var o = $.extend({

    }, options);


    _this.init = function() {
        _elem.find('.search-notes-wrapper input[type="text"]').on('keyup', function() {
            var $value = $(this).val();

            _this.searchNotes($value);
        });
    };

    _this.searchNotes = function($value) {
        if ($value !== '')
        {
            _notes.find('.note').addClass('hidden');

            _notes.find('.note').each(function() {
                var $this = $(this);
                var $message = $this.find('.note-information').html();
                $message = $message.replace(/(<([^>]+)>)/ig, '');

                console.log($message);

                if ($message.toLowerCase().indexOf($value.toLowerCase()) !== -1)
                {
                    $this.addClass('visible').removeClass('hidden');
                }
            });
        }
        else
        {
            _notes.find('.note').removeClass('hidden');
        }
    };

    _this.init();
};